import { atom } from "recoil";
import { User } from "../interfaces/User";

const userState = atom({ key: "user", default: {} as User });

export default userState;
